// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHero_videoContainer__HCWw7","videoPlayer":"VideoHero_videoPlayer__FhvQk","content":"VideoHero_content__Ie8yN"};